import {
  fromDateTimeComponentsWithOnCall,
  getShiftDurations,
} from '@bemlo/schedule'

import { UIDraftShift, UIShift } from '../types'

export const convertUIDraftShiftToShift = (draft: UIDraftShift): UIShift => {
  const dateTime = fromDateTimeComponentsWithOnCall(
    draft.date,
    draft.startTime,
    draft.endTime,
    draft.onCallTime,
  )

  const onCallTime =
    draft.onCallTime && dateTime.onCallTime
      ? {
          type: draft.onCallTime.type,
          startTime: draft.onCallTime.startTime,
          endTime: draft.onCallTime.endTime,
          startDateTime: dateTime.onCallTime.startDateTime,
          endDateTime: dateTime.onCallTime.endDateTime,
        }
      : null

  const durations = getShiftDurations({
    startDateTime: dateTime.startDateTime,
    endDateTime: dateTime.endDateTime,
    breakTime: draft.breakTime,
    onCallTime,
  })

  return {
    scheduleSlotId: undefined,
    status: 'DRAFT',
    ...draft,
    startDateTime: dateTime.startDateTime,
    endDateTime: dateTime.endDateTime,
    onCallTime,
    durations,
    isArchived: false,
    isPublished: false,
    isTendered: false,
    isBooked: false,
    isUrgent: false,
  }
}
